export enum LogEvent {
  LIVECHAT_GLOBAL_ERROR = 'livechat_global_error',
  LIVECHAT_LOCALSTORAGE_QUOTA = 'livechat_localstorage_quota',
  LIVECHAT_START_SESSION_ERROR = 'livechat_start_session_error',
  LIVECHAT_TEST_EVENT = 'livechat_test_event',
  LIVECHAT_CHAT_INPUT_STATE_CHANGED = 'livechat_chat_input_state_changed',
  LIVECHAT_WEBSOCKET_EVENT = 'livechat_websocket_event',
  LIVECHAT_FAILED_TO_SEND_FILE_ERROR = 'livechat_failed_to_send_file_error',
  LIVECHAT_PERFORMANCE_LOG = 'livechat_performance_log',
  LIVECHAT_REQUEST_PERFORMANCE_LOG = 'livechat_request_performance_log',
  LIVECHAT_ACCESS = 'livechat_access',
  LIVECHAT_FAILED_TO_ATTACH_ERROR = 'livechat_failed_to_attach_error',
  LIVECHAT_SCROLL_MORE_CHATS = 'livechat_scroll_more_chats',
  LIVECHAT_CHANGE_PERIOD = 'livechat_change_period',
  LIVECHAT_OPEN_FILTERS = 'livechat_open_filters',
  LIVECHAT_VIEW_LAST_INTERACTION = 'livechat_view_last_interaction',
  LIVECHAT_CHANGE_COMPANIES = 'livechat_change_companies',
  LIVECHAT_CHANGE_ASSIGNED_ATTENDANTS = 'livechat_change_assigned_attendants',
  LIVECHAT_CHANGE_ASSIGNED_TAGS = 'livechat_change_assigned_tags',
  LIVECHAT_CHANGE_FILTER_STATUS = 'livechat_change_filter_status',
  LIVECHAT_CHANGE_TAB_FILTER = 'livechat_change_tab_filter',
  LIVECHAT_APPLY_FILTERS = 'livechat_apply_filters',
  LIVECHAT_RESET_FILTERS = 'livechat_reset_filters',
  LIVECHAT_CHANGE_FILTER_READ = 'livechat_change_filter_read',
  LIVECHAT_OPEN_SEARCH = 'livechat_open_search',
  LIVECHAT_DO_SEARCH = 'livechat_do_search',
  LIVECHAT_CLOSE_SEARCH = 'livechat_close_search',
  LIVECHAT_OPEN_CHAT = 'livechat_open_chat',
  LIVECHAT_INSIDE_CHAT_SCROLL = 'livechat_inside_chat_scroll',
  LIVECHAT_CHAT_CLICK_IMAGE = 'livechat_chat_click_image',
  LIVECHAT_CHAT_DOWNLOAD_IMAGE = 'livechat_chat_download_image',
  LIVECHAT_CHAT_PLAY_AUDIO = 'livechat_chat_play_audio',
  LIVECHAT_CHAT_PLAY_VIDEO = 'livechat_chat_play_video',
  LIVECHAT_CHAT_DOWNLOAD_FILE = 'livechat_chat_download_file',
  LIVECHAT_CHAT_COPY_CONTACT_PHONE = 'livechat_chat_copy_contact_phone',
  LIVECHAT_CHAT_UNSUPPORTED_MEDIA = 'livechat_chat_unsupported_media',
  LIVECHAT_CHAT_LINK_CLICK = 'livechat_chat_link_click',
  LIVECHAT_TAKE_CONTROL_CHAT = 'livechat_take_control_chat',
  LIVECHAT_SEND_MESSAGE = 'livechat_send_message',
  LIVECHAT_SOLVE_CHAT = 'livechat_solve_chat',
  LIVECHAT_REOPEN_CHAT = 'livechat_reopen_chat',
  LIVECHAT_TURN_ROBOT_ON = 'livechat_turn_robot_on',
  LIVECHAT_OPEN_CONTACT_DETAILS = 'livechat_open_contact_details',
  LIVECHAT_EDIT_CONTACT_EMAIL = 'livechat_edit_contact_email',
  LIVECHAT_EDIT_CONTACT_PHONE = 'livechat_edit_contact_phone',
  LIVECHAT_EDIT_CONTACT_NAME = 'livechat_edit_contact_name',
  LIVECHAT_EDIT_CONTACT_NOTES = 'livechat_edit_contact_notes',
  LIVECHAT_BACK_TO_ADMIN = 'livechat_back_to_admin',
  LIVECHAT_OPEN_USER_HEADER = 'livechat_open_user_header',
  LIVECHAT_OPEN_EMOJI_PICKER = 'livechat_open_emoji_picker',
  LIVECHAT_OPEN_EMOJI_SUGGESTION = 'livechat_open_emoji_suggestion',
  LIVECHAT_LOGOFF = 'livechat_logoff',
  LIVECHAT_CHANGE_LANGUAGE = 'livechat_change_language',
  LIVECHAT_SET_STATUS = 'livechat_set_status',
  LIVECHAT_START_SEND_ATTACHMENT = 'livechat_start_send_attachment',
  LIVECHAT_ATTACHMENT_PREVIEW_NAVIGATE = 'livechat_attachment_preview_navigate',
  LIVECHAT_ATTACHMENT_PREVIEW_REMOVE = 'livechat_attachment_preview_remove',
  LIVECHAT_ATTACHMENT_PREVIEW_ADD = 'livechat_attachment_preview_add',
  LIVECHAT_SEND_ATTACHMENT = 'livechat_send_attachment',
  LIVECHAT_CANCEL_SEND_ATTACHMENT = 'livechat_cancel_send_attachment',
  LIVECHAT_CLICK_SEND_AUDIO = 'livechat_click_send_audio',
  LIVECHAT_SEND_AUDIO = 'livechat_send_audio',
  LIVECHAT_CANCEL_SEND_AUDIO = 'livechat_cancel_send_audio',
  LIVECHAT_START_CHAT = 'livechat_start_chat',
  LIVECHAT_START_CHAT_WITHOUT_WHATSAPP = 'livechat_start_chat_without_whatsapp',
  LIVECHAT_START_CHAT_WHATSAPP = 'livechat_start_chat_whatsapp',
  LIVECHAT_START_CHAT_WHATSAPP_BSUID = 'livechat_start_chat_whatsapp_bsuid',
  LIVECHAT_START_CHAT_WHATSAPP_WITHOUT_CREDITS = 'livechat_start_chat_whatsapp_without_credits',
  LIVECHAT_CANCEL_START_CHAT_WHATSAPP = 'livechat_cancel_start_chat_whatsapp',
  LIVECHAT_CANCEL_COMPANY_LIST = 'livechat_cancel_company_list',
  LIVECHAT_BACK_SEND_MESSAGE = 'livechat_back_send_message',
  LIVECHAT_CANCEL_SEND_MESSAGE = 'livechat_cancel_send_message',
  LIVECHAT_START_CHAT_WHATSAPP_SEND = 'livechat_start_chat_whatsapp_send',
  LIVECHAT_START_CHAT_WHATSAPP_OPEN_HISTORY = 'livechat_start_chat_whatsapp_open_history',
  LIVECHAT_START_CHAT_WHATSAPP_NEW_TEMPLATE = 'livechat_start_chat_whatsapp_new_template',
  LIVECHAT_START_CHAT_WHATSAPP_MORE_CREDITS = 'livechat_start_chat_whatsapp_more_credits',
  LIVECHAT_CONNECTION_RESTABLISHED = 'livechat_connection_restablished',
  LIVECHAT_ARTICLE_META_CLOSED_CONVERSATION_WINDOW = 'livechat_article_meta_closed_conversation_window',
  LIVECHAT_ARTICLE_LIMITS_ATTACHMENT = 'livechat_article_limits_attachment',
  LIVECHAT_CHAT_MARKED_READ = 'livechat_chat_marked_read',
  LIVECHAT_CHAT_MARK_UNREAD = 'livechat_chat_mark_unread',
  LIVECHAT_HEADER_CLICK_TAGS = 'livechat_header_click_tags',
  LIVECHAT_LIST_ASSIGNED_TAGS = 'livechat_list_assigned_tags',
  LIVECHAT_LIST_TAGS_REMOVE = 'livechat_list_tags_remove',
  LIVECHAT_LIST_TAGS_SEARCH = 'livechat_list_tags_search',
  LIVECHAT_TAGS_ASSIGN = 'livechat_tags_assign',
  LIVECHAT_LIST_ASSIGNED_TAGS_CANCEL = 'livechat_list_assigned_tags_cancel',
  LIVECHAT_LIST_ASSIGNED_TAGS_SAVE = 'livechat_list_assigned_tags_save',
  LIVECHAT_LIST_ASSIGNED_TAGS_CREATE = 'livechat_list_assigned_tags_create',
  LIVECHAT_LIST_ASSIGNED_TAGS_EDIT = 'livechat_list_assigned_tags_edit',
  LIVECHAT_LIST_INCREASE_PERIOD = 'livechat_list_increase_period',
  LIVECHAT_LIST_REMOVE_CHIP_FILTER = 'livechat_list_remove_chip_filter',
  LIVECHAT_CREATE_TAG_CANCEL = 'livechat_create_tag_cancel',
  LIVECHAT_CREATE_TAG_SAVE = 'livechat_create_tag_save',
  LIVECHAT_EDIT_TAG_CANCEL = 'livechat_edit_tag_cancel',
  LIVECHAT_EDIT_TAG_SAVE = 'livechat_edit_tag_save',
  LIVECHAT_EDIT_TAG_START_DELETE = 'livechat_edit_tag_start_delete',
  LIVECHAT_DELETE_TAG_CANCEL = 'livechat_delete_tag_cancel',
  LIVECHAT_DELETE_TAG_SAVE = 'livechat_delete_tag_save',
  LIVECHAT_CHANGE_CHANNEL_CLICK = 'livechat_change_channel_click',
  LIVECHAT_CHANGE_CHANNEL_SHOW = 'livechat_change_channel_show',
  LIVECHAT_CHANGE_CHANNEL_CHOOSED = 'livechat_change_channel_choosed',
  LIVECHAT_START_TRANSLATE_SEND_MESSAGE = 'livechat_start_translate_send_message',
  LIVECHAT_CANCEL_TRANSLATE_SEND_MESSAGE = 'livechat_cancel_translate_send_message',
  LIVECHAT_DO_TRANSLATE_SEND_MESSAGE = 'livechat_do_translate_send_message',
  LIVECHAT_DO_TRANSLATE_HISTORY_MESSAGE = 'livechat_do_translate_history_message',
  LIVECHAT_CANCEL_TRANSLATE_HISTORY_MESSAGE = 'livechat_cancel_translate_history_message',
  LIVECHAT_START_CHANGE_LANGUAGE_TRANSLATE_HISTORY_MESSAGE = 'livechat_start_change_language_translate_history_message',
  LIVECHAT_CANCEL_CHANGE_LANGUAGE_TRANSLATE_HISTORY_MESSAGE = 'livechat_cancel_change_language_translate_history_message',
  LIVECHAT_DO_CHANGE_LANGUAGE_TRANSLATE_HISTORY_MESSAGE = 'livechat_do_change_language_translate_history_message',
  LIVECHAT_TEMPLATES_OPEN = 'livechat_templates_open',
  LIVECHAT_TEMPLATES_FILTER_COMPANY = 'livechat_templates_filter_company',
  LIVECHAT_TEMPLATES_FILTER_COMPANY_CHANGE = 'livechat_templates_filter_company_change',
  LIVECHAT_TEMPLATES_CHOSEN = 'livechat_templates_chosen',
  LIVECHAT_TEMPLATES_MANAGE = 'livechat_templates_manage',
  LIVECHAT_TEMPLATES_START_EDIT = 'livechat_templates_start_edit',
  LIVECHAT_TEMPLATES_CANCEL_EDIT = 'livechat_templates_cancel_edit',
  LIVECHAT_TEMPLATES_SAVE_EDIT = 'livechat_templates_save_edit',
  LIVECHAT_TEMPLATES_START_DELETE = 'livechat_templates_start_delete',
  LIVECHAT_TEMPLATES_CANCEL_DELETE = 'livechat_templates_cancel_delete',
  LIVECHAT_TEMPLATES_CONFIRM_DELETE = 'livechat_templates_confirm_delete',
  LIVECHAT_TEMPLATES_START_CREATE = 'livechat_templates_start_create',
  LIVECHAT_TEMPLATES_CANCEL_CREATE = 'livechat_templates_cancel_create',
  LIVECHAT_TEMPLATES_SAVE_CREATE = 'livechat_templates_save_create',
  LIVECHAT_OPEN_HISTORY_APP = 'livechat_open_history_app',
  LIVECHAT_OPEN_APP = 'livechat_open_app',
  LIVECHAT_OPEN_APP_ERROR = 'livechat_open_app_error',
  LIVECHAT_OPEN_APP_SESSION_TIMEOUT = 'livechat_open_app_session_timeout',
  LIVECHAT_FAILED_ASSUME_ATTENDANCE = 'livechat_failed_assume_attendance',
  LIVECHAT_UNLOAD_APP_WARNING = 'livechat_unload_app_warning',
  LIVECHAT_TRANSFER_ASSIGNED_OPEN = 'livechat_transfer_assigned_open',
  LIVECHAT_TRANSFER_ASSIGNED_SEARCH = 'livechat_transfer_assigned_search',
  LIVECHAT_TRANSFER_ASSIGNED_CHANGE_LIST = 'livechat_transfer_assigned_change_list',
  LIVECHAT_TRANSFER_ASSIGNED_DONE = 'livechat_transfer_assigned_done',
  LIVECHAT_OPEN_ATTACHMENT_HELP = 'livechat_open_attachment_help',
  LIVECHAT_AUDIO_RECORD_FAILED = 'livechat_audio_record_failed',
  LIVECHAT_WEBSOCKET_ERROR = 'livechat_websocket_error',
  LIVECHAT_WEBSOCKET_TRYING_TO_CONNECT = 'livechat_websocket_trying_to_connect',
  LIVECHAT_WEBSOCKET_RECONNECTED = 'livechat_websocket_reconnected',
  LIVECHAT_WEBSOCKET_RECONNECT_FAILED = 'livechat_websocket_reconnect_failed',
  LIVECHAT_WEBSOCKET_CONNECTED = 'livechat_websocket_connected',
  LIVECHAT_WEBSOCKET_STOPPED = 'livechat_websocket_stopped',
  LIVECHAT_WEBSOCKET_DISCONNECTED = 'livechat_websocket_disconnected',
  LIVECHAT_WEBSOCKET_ERROR_FINISHED_RETRY = 'livechat_websocket_error_finished_retry',
  LIVECHAT_WEBSOCKET_STALE_CONNECTION_DETECTED = 'livechat_websocket_stale_connection_detected',
  LIVECHAT_CONTACT_LOOKUP_SOCKET_WAIT_TIMEOUT = 'livechat_contact_lookup_socket_wait_timeout',
  LIVECHAT_OPEN_HELP_CENTER = 'livechat_open_help_center',
  LIVECHAT_START_WHATSAPP_INVITE = 'livechat_start_whatsapp_invite',
  LIVECHAT_CANCEL_WHATSAPP_INVITE = 'livechat_cancel_whatsapp_invite',
  LIVECHAT_SEND_WHATSAPP_INVITE = 'livechat_send_whatsapp_invite',
  LIVECHAT_REQUEST_CONTACT_INFO = 'livechat_request_contact_info',
  LIVECHAT_WHATSAPP_INVITE_START_CHAT = 'livechat_whatsapp_invite_start_chat',
  LIVECHAT_OPEN_CONTACT_NOTES = 'livechat_open_contact_notes',
  LIVECHAT_CLOSE_CONTACT_NOTES = 'livechat_close_contact_notes',
  LIVECHAT_CHAT_COPY_FIXED_ADDRESS = 'livechat_chat_copy_fixed_address',
  LIVECHAT_APP_OPEN_RESERVATIONS_MANAGER = 'livechat_app_open_reservations_manager',
  LIVECHAT_APP_CLOSE_RESERVATIONS_MANAGER = 'livechat_app_close_reservations_manager',
  LIVECHAT_APP_OPEN_CHRONOS = 'livechat_app_open_chronos',
  LIVECHAT_APP_CLOSE_CHRONOS = 'livechat_app_close_chronos',
  LIVECHAT_APP_OPEN_START_CONVERSATION = 'livechat_app_open_start_conversation',
  LIVECHAT_APP_CLOSE_START_CONVERSATION = 'livechat_app_close_start_conversation',
  LIVECHAT_APP_OPEN_TASKS = 'livechat_app_open_tasks',
  LIVECHAT_APP_CLOSE_TASKS = 'livechat_app_close_tasks',
  LIVECHAT_APP_OPEN_MIDAS = 'livechat_app_open_midas',
  LIVECHAT_APP_CLOSE_MIDAS = 'livechat_app_close_midas',
  LIVECHAT_QUICK_RESET_FILTERS = 'livechat_quick_reset_filters',
  LIVECHAT_QUICK_FILTER_APPLY = 'livechat_quick_filter_apply',
  LIVECHAT_QUICK_FILTER_REMOVE = 'livechat_quick_filter_remove',
  LIVECHAT_NOTIFICATION_BROWSER_WITHOUT_HANDLER = 'livechat_notification_browser_without_handler',
  LIVECHAT_NOTIFICATION_GET_TOKEN = 'livechat_notification_token',
  LIVECHAT_NOTIFICATION_GET_TOKEN_FAILED = 'livechat_notification_token_failed',
  LIVECHAT_NOTIFICATION_WITHOUT_VALID_TOKEN = 'livechat_notification_without_valid_token',
  LIVECHAT_NOTIFICATION_SAVE_TOKEN_FAILED = 'livechat_notification_save_token_failed',
  LIVECHAT_NOTIFICATION_DELETE_TOKEN_FAILED = 'livechat_notification_delete_token_failed',
  LIVECHAT_NOTIFICATION_PERMISSION_DENIED = 'livechat_notification_permission_denied',
  LIVECHAT_NOTIFICATION_PERMISSION_REQUEST_FAILED = 'livechat_notification_permission_request_failed',
  LIVECHAT_OPEN_NEW_EMAIL = 'livechat_open_new_email',
  LIVECHAT_APP_OPEN_EMAIL = 'livechat_app_open_email',
  LIVECHAT_APP_CLOSE_EMAIL = 'livechat_app_close_email',
  LIVECHAT_OPEN_EMAIL_THREAD = 'livechat_open_email_thread',
  LIVECHAT_ANSWER_EMAIL = 'livechat_answer_email',
  LIVECHAT_OPEN_REPLY_EMAIL = 'livechat_open_reply_email',
  LIVECHAT_OPEN_REPLY_ALL_EMAIL = 'livechat_open_reply_all_email',
  LIVECHAT_OPEN_FORWARD_EMAIL = 'livechat_open_forward_email',
  LIVECHAT_NOTIFICATION_PUSH_ARRIVING = 'livechat_notification_push_arriving',
  LIVECHAT_NOTIFICATION_PUSH_ARRIVING_BACKGROUND = 'livechat_notification_push_arriving_background',
  LIVECHAT_OPEN_NEXT_ATTENDANCE_FROM_ARCHIVED_CTA = 'livechat_open_next_attendance_from_archived_cta',
  LIVECHAT_LOAD_ASKSTORE_APP_ERROR = 'livechat_load_askstore_app_error',
  LIVECHAT_APP_OPEN_WEBPHONE = 'livechat_app_open_webphone',
  LIVECHAT_APP_CLOSE_WEBPHONE = 'livechat_app_close_webphone',
  LIVECHAT_MEDIA_UPLOAD_ERROR = 'livechat_media_upload_error',
  LIVECHAT_MEDIA_PRE_SIGNED_URL_START = 'livechat_media_pre_signed_url_start',
  LIVECHAT_MEDIA_PRE_SIGNED_URL_SUCCESS = 'livechat_media_pre_signed_url_success',
  LIVECHAT_MEDIA_PRE_SIGNED_URL_ERROR = 'livechat_media_pre_signed_url_error',
  LIVECHAT_ATTACHMENT_IN_MEMORY_READ = 'livechat_attachment_in_memory_read',
  LIVECHAT_DARK_MODE = 'livechat_dark_mode',
  LIVECHAT_USE_TRANSCRIPTION_AUDIO = 'livechat_use_transcription_audio',
  LIVECHAT_SOPHIA_SPELL_CHECKER_ACCEPT = 'livechat_sophia_spell_checker_accept',
  LIVECHAT_SOPHIA_SPELL_CHECKER_CLOSE = 'livechat_sophia_spell_checker_close',
  LIVECHAT_OPEN_INTENT_TRACK = 'livechat_open_intent_track',
  LIVECHAT_OPEN_INTENT_TRACK_AI_DATA_HUB = 'livechat_open_intent_track_ai_data_hub',
  LIVECHAT_OPEN_INTENT_TRACK_HELP_CENTER = 'livechat_open_intent_track_help_center',
  LIVECHAT_IFRAME_HEALTHCHECK_NOT_RECEIVED_PONG = 'livechat_iframe_healthcheck_not_received_pong',
  LIVECHAT_IFRAME_HEALTHCHECK_RECOVERED = 'livechat_iframe_healthcheck_recovered',
  LIVECHAT_IFRAME_HEALTHCHECK_PHONE_APP_REINSTANTIATION_TRIGGERED = 'livechat_iframe_healthcheck_phone_app_reinstantiation_triggered',
  LIVECHAT_IFRAME_HEALTHCHECK_ERROR_CHECKING_IFRAME_VISIBILITY = 'livechat_iframe_healthcheck_error_checking_iframe_visibility',
  LIVECHAT_IFRAME_HEALTHCHECK_SUBSCRIPTION = 'livechat_iframe_healthcheck_subscription',
  LIVECHAT_START_CHAT_WHATSAPP_MESSAGE_BUBBLE = 'livechat_start_chat_whatsapp_message_bubble',
  LIVECHAT_AUDIO_PLAYER_PLAY_ERROR = 'livechat_audio_player_play_error',
  LIVECHAT_AUDIO_PLAYER_STOP_ERROR = 'livechat_audio_player_stop_error',
  LIVECHAT_PHONE_ONLINE_BEFORE_UNLOAD = 'livechat_phone_online_before_unload',
  LIVECHAT_PHONE_ONLINE_UNLOAD = 'livechat_phone_online_unload',
  LIVECHAT_PHONE_STATUS_CONFIRMATION_MODAL_CONFIRMED = 'livechat_phone_status_confirmation_modal_confirmed',
  LIVECHAT_PHONE_STATUS_CONFIRMATION_MODAL_CANCELED = 'livechat_phone_status_confirmation_modal_canceled',
  LIVECHAT_PHONE_AGENT_ACTIVATION_CHECK = 'livechat_phone_agent_activation_check',
  LIVECHAT_KANBAN_OPEN = 'livechat_kanban_open',
  LIVECHAT_KANBAN_CLOSE = 'livechat_kanban_close',
  LIVECHAT_KANBAN_MINIMIZE = 'livechat_kanban_minimize',
  LIVECHAT_KANBAN_RESTORE = 'livechat_kanban_restore',
  LIVECHAT_KANBAN_TOGGLE_CONFIG = 'livechat_kanban_toggle_config',
  LIVECHAT_KANBAN_ATTENDANCE_CLICK = 'livechat_kanban_attendance_click',
  LIVECHAT_KANBAN_PIPELINE_CREATE = 'livechat_kanban_pipeline_create',
  LIVECHAT_KANBAN_PIPELINE_EDIT = 'livechat_kanban_pipeline_edit',
  LIVECHAT_KANBAN_PIPELINE_SAVE = 'livechat_kanban_pipeline_save',
  LIVECHAT_KANBAN_PIPELINE_DELETE = 'livechat_kanban_pipeline_delete',
  LIVECHAT_KANBAN_PIPELINE_DUPLICATE = 'livechat_kanban_pipeline_duplicate',
  LIVECHAT_KANBAN_PIPELINE_SELECT = 'livechat_kanban_pipeline_select',
  LIVECHAT_BLOCK_CONTACT = 'livechat_block_contact',
  LIVECHAT_BLOCKED_CONTACTS_LIST = 'livechat_blocked_contacts_list',
  LIVECHAT_BLOCKED_CONTACTS_BLOCK = 'livechat_blocked_contacts_block',
  LIVECHAT_BLOCKED_CONTACTS_UNBLOCK = 'livechat_blocked_contacts_unblock',
  LIVECHAT_KANBAN_EXPORT_OPEN = 'livechat_kanban_export_open',
  LIVECHAT_KANBAN_EXPORT_CLOSE = 'livechat_kanban_export_close',
  LIVECHAT_KANBAN_EXPORT_TOGGLE_LANE = 'livechat_kanban_export_toggle_lane',
  LIVECHAT_KANBAN_EXPORT_CHANGE_MODE = 'livechat_kanban_export_change_mode',
  LIVECHAT_KANBAN_EXPORT_START = 'livechat_kanban_export_start',
  LIVECHAT_KANBAN_EXPORT_SUCCESS = 'livechat_kanban_export_success',
  LIVECHAT_KANBAN_EXPORT_ERROR = 'livechat_kanban_export_error',
  LIVECHAT_EXPORT_CONVERSATION_START = 'livechat_export_conversation_start',
  LIVECHAT_EXPORT_CONVERSATION_SUCCESS = 'livechat_export_conversation_success',
  LIVECHAT_EXPORT_CONVERSATION_ERROR = 'livechat_export_conversation_error',
  LIVECHAT_CHAT_SEARCH_OPENED_KEYBOARD = 'livechat_chat_search_opened_keyboard',
  LIVECHAT_CHAT_SEARCH_OPENED_BUTTON = 'livechat_chat_search_opened_button',
  LIVECHAT_SEND_TEXT_LOG = 'livechat_send_text_log',
  LIVECHAT_KANBAN_LANE_SORT_CHANGE = 'livechat_kanban_lane_sort_change',
  LIVECHAT_CHAT_SEARCH_NAVIGATE = 'livechat_chat_search_navigate',
  KANBAN_TAG_INFO_MODAL_CANCEL = 'kanban_tag_info_modal_cancel',
  KANBAN_TAG_INFO_MODAL_CONFIRM = 'kanban_tag_info_modal_confirm',
  LIVECHAT_KANBAN_FEEDBACK_CREATION_SUBMIT = 'livechat_kanban_feedback_creation_submit',
  LIVECHAT_KANBAN_FEEDBACK_CREATION_SKIP = 'livechat_kanban_feedback_creation_skip',
  LIVECHAT_KANBAN_FEEDBACK_USAGE_SUBMIT = 'livechat_kanban_feedback_usage_submit',
  LIVECHAT_KANBAN_FEEDBACK_USAGE_SKIP = 'livechat_kanban_feedback_usage_skip',
  LIVECHAT_KANBAN_DRAG_DROP_SUCCESS = 'livechat_kanban_drag_drop_success',
  LIVECHAT_KANBAN_DRAG_DROP_CANCELLED = 'livechat_kanban_drag_drop_cancelled',
  LIVECHAT_KANBAN_DRAG_DROP_GO_BACK_BLOCKED = 'livechat_kanban_drag_drop_go_back_blocked',
  LIVECHAT_KANBAN_DRAG_DROP_LANE_BLOCKED = 'livechat_kanban_drag_drop_lane_blocked',
  LIVECHAT_KANBAN_DRAG_DROP_AUTO_TAGS_ONLY = 'livechat_kanban_drag_drop_auto_tags_only',
  LIVECHAT_KANBAN_DRAG_DROP_USER_CANCELLED = 'livechat_kanban_drag_drop_user_cancelled',
  LIVECHAT_KANBAN_ATTENDANCE_LIST_LIMIT_REACHED = 'livechat_kanban_attendance_list_limit_reached',
  LIVECHAT_STATE_ACTION = 'livechat_state_action',
  LIVECHAT_MESSAGE_COST_STATE_SHOWN = 'livechat_message_cost_state_shown',
  LIVECHAT_CREDITS_ALERT_SHOWN = 'livechat_credits_alert_shown',
  LIVECHAT_CREDITS_MODAL_V2_OPEN = 'livechat_credits_modal_v2_open',
  LIVECHAT_JWT_SCHEDULED_REFRESH_SUCCESS = 'livechat_jwt_scheduled_refresh_success',
  LIVECHAT_JWT_SCHEDULED_REFRESH_EXPIRED = 'livechat_jwt_scheduled_refresh_expired',
  LIVECHAT_JWT_INTERCEPTOR_REFRESH_SUCCESS = 'livechat_jwt_interceptor_refresh_success',
  LIVECHAT_JWT_INTERCEPTOR_REFRESH_EXPIRED = 'livechat_jwt_interceptor_refresh_expired',
  LIVECHAT_JWT_INTERCEPTOR_REFRESH_COOKIE_NOT_FOUND = 'livechat_jwt_interceptor_refresh_cookie_not_found',
  LIVECHAT_JWT_SCHEDULED_REFRESH_COOKIE_NOT_FOUND = 'livechat_jwt_scheduled_refresh_cookie_not_found',
  LIVECHAT_NOT_FOUND_AUTH_OR_COOKIE = 'livechat_not_found_auth_or_cookie',
  LIVECHAT_SESSION_EXPIRED = 'livechat_session_expired',
  LIVECHAT_VERSION_UPDATE_CLICKED = 'livechat_version_update_clicked',
  LIVECHAT_ECONOMY_MODE_TOGGLE = 'livechat_economy_mode_toggle',
  LIVECHAT_ECONOMY_ENQUEUE = 'livechat_economy_enqueue',
  LIVECHAT_ECONOMY_SEND_ALL = 'livechat_economy_send_all',
  LIVECHAT_ECONOMY_SOPHIA_REWRITE = 'livechat_economy_sophia_rewrite',
  LIVECHAT_IMAGE_ECONOMY_COMBINE = 'livechat_image_economy_combine',
  LIVECHAT_IMAGE_ECONOMY_COMBINE_FAILED = 'livechat_image_economy_combine_failed',
  LIVECHAT_ECONOMY_MEDIA_CAPTION = 'livechat_economy_media_caption',
  LIVECHAT_UNTRACKED_REQUEST_LOG = 'livechat_untracked_request_log',
  LIVECHAT_CHILD_EVENT_UNKNOWN = 'livechat_child_event_unknown',
  LIVECHAT_CHILD_EVENT_INVALID_METADATA = 'livechat_child_event_invalid_metadata',
  LIVECHAT_CHILD_EVENT_INVALID_ORIGIN = 'livechat_child_event_invalid_origin',
  LIVECHAT_FEP_CHAT_OPENED = 'livechat_fep_chat_opened',
  LIVECHAT_HEADER_BACK = 'livechat_header_back',
  LIVECHAT_DOWNLOAD_HISTORY_JSON = 'livechat_download_history_json',
  LIVECHAT_OPEN_ROBOT_STATUS_DROPDOWN = 'livechat_open_robot_status_dropdown',
  LIVECHAT_OPEN_ATTENDANCE_STATUS_DROPDOWN = 'livechat_open_attendance_status_dropdown',
  LIVECHAT_SOLVE_WITHOUT_START_BOT = 'livechat_solve_without_start_bot',
  LIVECHAT_SOPHIA_SUGGEST = 'livechat_sophia_suggest',
  LIVECHAT_OPEN_BOOKING_DETAILS = 'livechat_open_booking_details',
  LIVECHAT_OPEN_EXPEDIA_DETAILS = 'livechat_open_expedia_details',
  LIVECHAT_TOGGLE_FORMATTING = 'livechat_toggle_formatting',
  LIVECHAT_HEADER_COPY_CONTACT_PHONE = 'livechat_header_copy_contact_phone',
  LIVECHAT_HEADER_CLICK_MORE_ITEMS = 'livechat_header_click_more_items',
  LIVECHAT_AUDIO_RECORD_SUCCEEDED = 'livechat_audio_record_succeeded',
  LIVECHAT_AUDIO_RECORD_EMPTY = 'livechat_audio_record_empty',
  LIVECHAT_AUDIO_RECORD_START_ERROR = 'livechat_audio_record_start_error',
  LIVECHAT_AUDIO_RECORD_STOP_ERROR = 'livechat_audio_record_stop_error',
  LIVECHAT_USER_IDLE = 'livechat_user_idle',
  LIVECHAT_USER_ACTIVE = 'livechat_user_active',
  LIVECHAT_CREDITS_REPORT_POLL_HELD = 'livechat_credits_report_poll_held',
  LIVECHAT_CREDITS_REPORT_POLL_RESUMED = 'livechat_credits_report_poll_resumed',
  LIVECHAT_EXPIRED_MEDIA_SHOWN = 'livechat_expired_media_shown',
}
